module.exports = __webpack_public_path__ + "img/下载.ac6e423f.png";